import { observable, action, runInAction, computed } from 'mobx'
import cloneDeep from 'lodash/cloneDeep'
import getValue from 'lodash/get'
import MainStore from '@components/Main/store'
import { message } from 'hljd'
import Api from '@api/kong_kong/CardAddApi'
import { getLocationQuery } from '@util'

export default class {
  constructor(stepTwoStore) {
    // 整个第二步的store
    this.stepTwoStore = stepTwoStore
  }

  // 预处理图片位置
  @observable pictureListPreview = []
  @observable pictureList = []
  // 限制张数
  @observable pictureLimit = 50
  @observable textLimit = 5000
  // 编辑区富文本内容
  @observable richTextInfo = ''
  @observable preLength = 0
  @observable setmealListStatus = true // true 时 为正常编辑 false 为引导页状态
  @observable isSingle = false
  @observable isShownWarningLength = false
  @observable isShownWarningSize = false
  @observable checkingWord = false

  @computed
  get pictureLength() {
    return this.pictureList.filter(el => el.kind == 1).length
  }

  addImageWarning = () => {
    message.warning('图片数量超出限制')
  }

  @action
  init = () => {
    // MainStore.scrollTopMain()
    const { set_meal_detail } = this.stepTwoStore.stepTwoData
    this.pictureList = set_meal_detail
      ? set_meal_detail.map(el => ({
          ...el,
          status: false // false是选中状态，这里不加应该也是一样的效果
        }))
      : [
          {
            kind: 3,
            content: {
              text: ''
            },
            status: true
          }
        ]
    this.isSingle = !!+getLocationQuery('isSingle')
  }
  @action
  save = () => {
    this.stepTwoStore.sessionPictureData = this.pictureList
    this.stepTwoStore.setStepTwoData()
  }

  @action
  addtext = () => {
    this.richTextInfo = ''
    const oldList = this.pictureList
    const activeIndex = this.pictureList.findIndex(el => el.status)
    if (activeIndex !== -1) {
      oldList[activeIndex].status = false
    }
    oldList.push({
      kind: 3,
      content: {
        text: ''
      },
      status: true
    })
    this.pictureList = oldList
    this.save()
    this.handleTextEditorPosition(true)
  }

  @action
  getUploadPictureLength = length => {
    // console.log('getUploadPictureLength length', length)
    // this.preLength = length
  }

  @action
  resetUploadState = () => {
    this.isShownWarningLength = false
    this.isShownWarningSize = false
  }

  @action
  checkImageSize = (up, err, errTip) => {
    if (err.code === plupload.FILE_SIZE_ERROR && !this.isShownWarningSize) {
      message.warning('图片大小超过了10M')
      this.isShownWarningSize = true
    }
  }

  @action
  uploadPicture = (file, link, info, uploader) => {
    const withInLimit =
      this.pictureListPreview.length +
        this.pictureList.filter(el => el.kind === 1).length <
      this.pictureLimit

    const height = info.height

    if (withInLimit) {
      if (height <= 2048) {
        runInAction(() => {
          this.pictureListPreview.push(this.getPictureData(link, info))
          this.stepTwoStore.centerStore.checkImg.checkCMYK(3, link)
        })
        this.preLength += 1
      } else {
        message.warning('图片高度超过了2048px')
        // this.isShownWarningLength = true
      }
      uploader.files = []
    }
  }
  @action
  getPictureData = (link, { width, height }) => ({
    kind: 1,
    content: {
      media_path: link,
      status: false,
      width,
      height
    }
  })

  @action
  sortPicture = sortPreviewList => {
    this.pictureListPreview = sortPreviewList
  }

  @action
  clearPreview = () => {
    this.preLength = 0
    this.pictureListPreview = []
  }
  @action
  savePreview = () => {
    if (
      this.pictureListPreview.length < this.preLength &&
      this.pictureList.length + this.preLength.length <= 50
    ) {
      return
    }
    this.pictureList = [...this.pictureList, ...this.pictureListPreview]
    this.clearPreview()
    setTimeout(() => {
      this.handleEditAreaPosition()
    }, 400)
    this.save()
  }
  @action
  deletePreviewPicture = index => {
    const oldList = this.pictureListPreview
    oldList.splice(index, 1)
    this.pictureListPreview = oldList
    this.preLength = this.preLength - 1
  }

  @action
  changeStatus = index => {
    this.pictureList = this.pictureList.map((el, i) => {
      return {
        ...el,
        status: index === i
      }
    })
    if (this.pictureList[index].kind == 3) {
      const content = this.pictureList[index].content.text
      this.richTextInfo = content
      this.handleTextEditorPosition()
    }
  }

  @action
  onPictureMove = (type, index) => {
    if (index != 0 && type == 'up') {
      ;[this.pictureList[index - 1], this.pictureList[index]] = [
        this.pictureList[index],
        this.pictureList[index - 1]
      ]
    } else if (index != this.pictureList.length - 1 && type == 'down') {
      ;[this.pictureList[index + 1], this.pictureList[index]] = [
        this.pictureList[index],
        this.pictureList[index + 1]
      ]
    }
    this.save()
    this.handleTextEditorPosition()
  }

  @action
  onPictureCopy = index => {
    const current = {
      ...this.pictureList[index],
      status: false
    }
    const oldList = this.pictureList
    oldList.splice(index + 1, 0, cloneDeep(current))
    this.pictureList = oldList
    this.save()
  }

  @action
  onPictureDelete = index => {
    const checkImage = getValue(
      this,
      'stepTwoStore.centerStore.checkImg.editImage',
      ''
    )
    const img = getValue(this.pictureList[index], 'content.media_path')
    img && checkImage && checkImage(3, '', img)
    const oldList = this.pictureList
    oldList.splice(index, 1)
    this.pictureList = oldList
    this.save()
  }

  @action
  onPictureReplace = index => (file, src, { width, height }) => {
    const checkImage = getValue(
      this,
      'stepTwoStore.centerStore.checkImg.editImage',
      ''
    )
    const img = getValue(this.pictureList[index], 'content.media_path')
    img && checkImage && checkImage(3, src, img)
    this.pictureList.splice(index, 1, {
      kind: 1,
      status: true,
      content: {
        media_path: src,
        width,
        height
      }
    })
    this.save()
  }
  @action
  richTextChange = value => {
    this.richTextInfo = value
    let richTextItem = this.pictureList.find(el => el.status)

    richTextItem.content.text = this.richTextInfo
    this.pictureList = [...this.pictureList]
    this.save()
  }

  /**
   * 左侧显示区域位置计算
   */
  handleGroupPosition = () => {
    const { contentMainDiv, scrollTopMain } = MainStore
    const offset = contentMainDiv.current.scrollHeight
    scrollTopMain(0, offset)
  }

  /**
   * 右侧编辑区域高度计算
   */
  handleEditAreaPosition = () => {
    setTimeout(() => {
      const scrollWrapper = document.querySelector('#sessionScrollWrapper') //  滚动区dom
      if (scrollWrapper) {
        scrollWrapper.scrollTop = scrollWrapper.scrollHeight
        this.handleTextEditorPosition()
      }
    }, 0)
  }

  handleTextEditorPosition = autoScrollBottom => {
    setTimeout(() => {
      const selectedIndex = this.pictureList.findIndex(item => item.status) // 选中的item的索引
      const sessionDomList = document.querySelectorAll(
        '#sessionPictureContainer>div'
      )
      const sessionDomBeforeSelectedList = Array.prototype.slice.call(
        sessionDomList,
        0,
        selectedIndex
      )
      const height = sessionDomBeforeSelectedList.reduce(
        (preHeight, session) => {
          return session.clientHeight + preHeight + 8
        },
        0
      )
      const textEditor = document.querySelector('#setMeal-richText-edit') //  文本编辑框
      if (textEditor) {
        textEditor.style.top = height + 88 + 'px'
        const scrollWrapper = document.querySelector('#sessionScrollWrapper') //  滚动区dom
        if (autoScrollBottom && scrollWrapper) {
          scrollWrapper.scrollTop = scrollWrapper.scrollHeight
        }
      }
    }, 0)
  }

  handleChangeShowList = status => {
    this.setmealListStatus = status
  }

  // 校验敏感词
  checkWord = async content => {
    this.checkingWord = true
    const { data } = await Api.checkWord({ content: content || 'a', type: 2 })
    this.checkingWord = false
    return data
  }
}
